module.exports = __webpack_public_path__ + "img/Metal Detector.231a1dd1.svg";